var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ReportPie from "../../../../components/Charts/ReportPie";
import ScoreBigBall from "../../../../components/ScoreBigBall";
import { useAiReportStore } from "../../../../store/ai-report/global-store";
import { Box } from 'fbm-ui';
var Report = function () {
    var reportResult = useAiReportStore(function (store) { return [store.reportResult]; }).reportResult;
    var _a = reportResult || {}, orderToken = _a.orderToken, score = _a.score, status = _a.status, _b = _a.collection, collection = _b === void 0 ? [] : _b;
    return (_jsx(Box, __assign({ width: "500px" }, { children: _jsxs(Box, __assign({ height: 300, sx: { position: 'relative' } }, { children: [_jsx(ReportPie, { id: orderToken || '', source: collection }), _jsx(ScoreBigBall, { score: score || 0, status: status })] })) })));
};
export default Report;
